
        import config, { initConfig } from '/js/config.js';
        
        async function initializeApp() {
            try {
                // Initialize configuration first
                const configData = await initConfig();
                
                // Initialize Supabase client
                const { createClient } = supabase;
                window.supabaseClient = createClient(
                    configData.supabaseUrl,
                    configData.supabaseAnonKey,
                    {
                        auth: {
                            autoRefreshToken: true,
                            persistSession: true,
                            detectSessionInUrl: true
                        }
                    }
                );
                
                console.log('Application initialized successfully');
                
                // Load admin.js module after successful initialization
                console.log('Loading admin module...');
                const adminModule = await import('/js/admin.js');
                await adminModule.init();
                console.log('Admin initialization complete');
            } catch (error) {
                console.error('Failed to initialize application:', error);
                // Redirect to home page if initialization fails
                window.location.href = '/';
            }
        }
        
        initializeApp();
    